import React from 'react';
import { EmotionDto } from '../interfaces/emotion';

interface EmotionSelectorProps {
    emocionesCatalogo: EmotionDto[];
    value: number[];
    onChange: (ids: number[]) => void;
}

const EmotionSelector: React.FC<EmotionSelectorProps> = ({ emocionesCatalogo, value, onChange }) => {
    const handleToggle = (id: number) => {
        if (value.includes(id)) {
            onChange(value.filter((e) => e !== id));
        } else {
            onChange([...value, id]);
        }
    };
    return (
        <div className='button-grid'>
            {emocionesCatalogo.map((emocion) => {
                const emocionId = typeof emocion.id_emocion === 'number' ? emocion.id_emocion : Number(emocion.id_emocion);
                return (
                    <button
                        key={emocionId}
                        className={`option-button${value.includes(emocionId) ? ' selected' : ''}`}
                        onClick={() => handleToggle(emocionId)}
                        type='button'
                    >
                        {emocion.nombre_emocion}
                    </button>
                );
            })}
        </div>
    );
};

export default EmotionSelector;
